import React, { FC, useRef } from 'react';
import { Row, Column } from '../../../../../../components/Layout/Grid';
import Text from "components/Text";
import { format } from 'date-fns';

import warningIcon from 'img/item-validity-modal-warning.svg';
import { colors } from "../../../../styles/colors";
import './styles.scss';

const ItemValidityModal: FC<any> = ({ item, selectedBudgetCd }: any) => {

  const boxRef = useRef<any>();
  let productSuggestion = item.productsSuggestion.find((i: any) => i.suggested);
  let itemBatches = productSuggestion.itemBatch.find((item: any) => item.distributionCenter === selectedBudgetCd);

  const extraBox =
    <>
      <div className="item-validity--info-header">
        <div className='item-validity--warning-icon'>
          <img src={warningIcon} />
        </div>
        <Text
          size={12}
          color={colors.viveoDarkBlue}
          className="item-validity--header-title mr-1">
          LOTES COM VALIDADE INFERIOR A 12 MESES
        </Text>
      </div>
      <Text
        size={12}
        color={colors.mfMediumGrey}
        className="item-validity--header-subtitle">
        As informações apresentadas abaixo são referentes ao CD escolhido.
      </Text>
      <hr className="item-validity--hr" />

      <Row style={{ justifyContent: 'space-between' }}>
        <Column style={{ marginRight: '40px', textAlign: 'left' }}>
          <Text
            size={12}
            color={colors.mfMediumGrey}>
            Prazo de Validade
          </Text>
          {itemBatches?.batches ? (
            itemBatches?.batches.map(
              (item: any) => {
                return (
                  <Text
                    size={12}
                    color={colors.blueDark}
                    className="font-bold item-validity--paddingTop">
                    {format(new Date(item.validity), "dd/MM/yyyy")}
                  </Text>
                );
              }
            )
          ) : ''
          }
        </Column>

        <Column style={{ marginRight: '60px', textAlign: 'left' }}>
          <Text
            size={12}
            color={colors.mfMediumGrey}>
            Lote
          </Text>
          {itemBatches?.batches ? (
            itemBatches?.batches.map(
              (item: any) => {
                return (
                  <Text
                    size={12}
                    lineHeight={'18px'}
                    color={colors.blueDark}
                    className="item-validity--paddingTop">
                    {item.batchCode}
                  </Text>
                );
              }
            )
          ) : ''
          }
        </Column>

        <Column style={{ textAlign: 'left' }}>
          <Text
            size={12}
            color={colors.mfMediumGrey}>
            Saldo no Estoque
          </Text>
          {itemBatches?.batches ? (
            itemBatches?.batches.map(
              (item: any) => {
                return (
                  <Text
                    size={12}
                    lineHeight={'18px'}
                    color={colors.blueDark}
                    className="item-validity--paddingTop">
                    {item.balance}
                  </Text>
                );
              }
            )
          ) : ''
          }
        </Column>
      </Row>

      <div className="stock-column--info-content" style={{ textAlign: 'left' }} ref={boxRef}>

      </div>
    </>;
  return <>{extraBox}</>;
};

export default ItemValidityModal;